import type { TacticalPluginTool } from "./types";

const tools = new Map<string, TacticalPluginTool>();

export function registerTacticalPlugin(tool: TacticalPluginTool): void {
  if (tools.has(tool.id)) {
    console.warn(`[tactical-plugins] overwrite plugin id=${tool.id}`);
  }
  tools.set(tool.id, tool);
}

export function listTacticalPlugins(): TacticalPluginTool[] {
  return Array.from(tools.values()).sort((a, b) => a.label.localeCompare(b.label, "ru"));
}

export function getTacticalPlugin(id: string): TacticalPluginTool | undefined {
  return tools.get(id);
}
